export class TabValidator {
	static #getTabIDs (){
		return Array.from (document.querySelectorAll ('.accordion-collapse')).map (el => el.id);
	}
	
	static isTabValidationNeeded (event){
		const tabIds = TabValidator.#getTabIDs ();
		const currentTab = document.querySelector ('.accordion-collapse.show');
		
		if (!currentTab)
			return false;
		
		const nextTabId = event.target.id;
		const nextTabIndex = tabIds.indexOf (nextTabId);
	    const currentTabIndex = tabIds.indexOf (currentTab.id);
	    
	    if (nextTabIndex < currentTabIndex)
	    	return false;
	    
	    return true;
	}
	
	static getCurrentTab (){
		return document.querySelector ('.accordion-collapse.show');
	}
}

if (typeof window !== 'undefined')
	window.TabValidator = TabValidator;
